var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nh-pop"},[_c('div',[_c('div',{on:{"click":_vm.popComShow}},[_vm._v(" 点击查看商品详情 ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }